<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        router-link.button-previous.mr-2(:to="{path: '/administracion/id/profile', query: {restart: false}}")
          i.fas.fa-chevron-left
        h1.m-0.d-inline-block.align-middle
          i Editar Perfil
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_bg-gray.rounded-xl
            .card-body
              form.d-flex.flex-row.flex-wrap
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Nombre
                  input.col.form-control(type="text" v-model="name" maxlength='100' placeholder='ingresa nombre' title='ingresa tu nombre')
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Descripción
                  textarea.form-control(v-model="description" maxlength='100' rows="3" placeholder='ingresa descripción' title='Descripción')
                  .col-auto.form-group.align-items-center.mb-0.pr-0
                .col-6.form-group.align-items-center.mb-4
                  label.font-weight-bold.col-3.pl-0.m-0 Lider de lideres
                  input.d-inline-block.ml-2(type="checkbox" v-model="leader_leaders" title='Selecciona si es lider de lideres')
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 DDD a realizar
                  input.col.form-control(type="number" v-model="suggested_ddd" maxlength='100' placeholder='0' max="100" title='Meta')
                .col-6.form-group.align-items-center.mb-4
                  label.font-weight-bold.col-3.pl-0.m-0 Realiza plan
                  input.d-inline-block.ml-2(type="checkbox" v-model="implement_plan" title='Selecciona si realizara plan')
                .col-6.form-group.align-items-center.mb-4 
                  label.font-weight-bold.col-3.pl-0.m-0 Realiza
                  input.d-inline-block.ml-2(type="radio" v-model="type_tracing" value="1")
                  label
                    small CP 
                  input.d-inline-block.ml-2(type="radio" v-model="type_tracing" value="0")
                  label
                    small SD
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 CP/SD a realizar
                  input.col.form-control(type="number" v-model="suggested_cp" maxlength='100' placeholder='0' max="100" title='Meta')
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 CP Mensual a realizar
                  input.col.form-control(type="number" v-model="suggested_mcp" maxlength='100' placeholder='0' max="100" title='Meta')

          .d-flex.flex-row.mt-5
            router-link.stepper-button.previous(to="/administracion/id/kpi-adherencia")
              i.material-icons
              span Volver
            button.col-auto.stepper-button.next.ml-auto(@click="updateProfileManager()")
              span Actualizar
              i.material-icons


</template>

<script>
import { mapActions } from 'vuex';
import { nullLiteralTypeAnnotation } from 'babel-types';
export default {
  name: 'AdministracionProfileEdit',
  data () {
    return {
      profile: null,
      name: null,
      description: null,
      suggested_cp: null,
      suggested_ddd: null,
      suggested_plan: null,
      suggested_mcp: null,
      tabs: ['home'],
      leader_leaders: null,
      type_tracing: null,
      implement_plan: null
    }
  },
  methods: {
    ...mapActions('profile', [
      'getProfileById', 'updateProfile'
    ]),
    setProfileProps() {      
      const vm = this      
      try {
        vm.name = vm.profile.name
        vm.description = vm.profile.description
        vm.implement_plan = vm.profile.suggested_plan ? true: false
        vm.suggested_ddd = vm.profile.suggested_ddd
        vm.suggested_cp = vm.profile.suggested_cp
        vm.leader_leaders = vm.profile.leader_leaders
        vm.suggested_mcp = vm.profile.suggested_mcp
        for (let tab of vm.profile.auth.tabs) {
          if (tab == 'confirmacion_procesos') {
            vm.type_tracing = "1"
          } else if (tab == 'seguimiento_diario') {
            vm.type_tracing = "0"
          }
        }
      } catch (e) {
        vm.notify(e)
        console.info(e)
      }
    },
    getProfileFromProps() {
      const vm = this
      if (vm.implement_plan) {
        vm.tabs.push('planificacion_semanal')
      }
      if (Number(vm.suggested_ddd) > 0) {
        vm.tabs.push('dialogo_desempeno')
      }
      if (vm.type_tracing == "1") {
        vm.tabs.push('confirmacion_procesos')
      } else if (vm.type_tracing == "0") {
        vm.tabs.push('seguimiento_diario')
      }
      return {
        id: vm.profile._id,
        name: vm.name,
        description: vm.description,
        suggested_plan: vm.implement_plan == true ? 1 : 0,
        suggested_cp: Number(vm.suggested_cp),
        suggested_ddd: Number(vm.suggested_ddd),
        suggested_mcp: Number(vm.suggested_mcp),
        leader_leaders: vm.leader_leaders,
        auth: {
          tabs: vm.tabs
        }
      }
    },
    loadDetail(id) {
      const vm = this
      const loading = vm.$toast.loading('Cargando Detalle...')      
      vm.getProfileById(id).then((profile) => {
        vm.profile = vm.$store.getters['profile/getProfile']
        vm.setProfileProps()
        loading.hide()
      }).catch(error => {
        vm.notify(error)
        loading.hide()
      })
    },
    notify(error = true, message) {
      const vm = this
      vm.$notify({
          type: error ? 'danger' : 'success',
          title: 'Notificación',
          content: message,
          closeable: true,
          duration: 5000
        })
    },
    cleanTabs() {
      const vm = this
      vm.tabs = ['home']
    },
    updateProfileManager() {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      if (vm.validate()) {
        const data = vm.getProfileFromProps()
        vm.updateProfile(data).then(result => {
          if (!result.success) {
            vm.cleanTabs()
            loading.hide()
            vm.notify(true, result.message)
          } else {
            loading.hide()
            vm.notify(false, 'Perfil actualizado')
          }
        }).catch(error => {
          loading.hide()
          vm.notify(true, error.payload.message)
        })
        loading.hide()
      } else {
        loading.hide()
      }
    },
    isValidInput(input) {
      return input !== undefined && input !== null
    },
    isValidInputPer(input) {
      return input >= 0 && input <= 100
    },
    isValidBoolean(input) {
      return input === false || input === true
    },
    validate() {
      const vm = this
      let valid = true
      let missing = ''
      if (!vm.isValidInput(vm.name)) {
        missing = 'Debe completar el campo nombre'
        valid = false
      } else if (!vm.isValidInput(vm.description)) {
        missing = 'Debe completar el campo descripción'
        valid = false
      } else if (!vm.isValidBoolean(vm.implement_plan)) {
        missing = 'Debe completar el campo realiza plan'
        valid = false
      } else if (!vm.isValidInputPer(vm.suggested_cp)) {
        missing = 'Debe completar el campo cuantos cp realizara'
        valid = false
      } else if (!vm.isValidInputPer(vm.suggested_ddd)) {
        missing = 'Debe completar el campo cuantos ddd realizara'
        valid = false
      } else if (!vm.isValidBoolean(vm.leader_leaders)) {
        missing = 'Debe completar el campo lider de lideres'
        valid = false
      }

      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: missing,
          closeable: true,
          duration: 5000
        })
        return false
      }
    }
  },
  mounted() {
    const vm = this;
    vm.loadDetail(this.$route.params.id)
    this.$emit('can-continue', { value: true })
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-profile-edit.vue